// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-notifications__not-found[data-v-6e58f626]{text-align:center;padding:40px;display:flex;flex-direction:column;align-content:center;align-items:center;gap:25px}.customer-notifications__not-found img[data-v-6e58f626]{width:100%;max-width:430px}.customer-notifications__not-found p[data-v-6e58f626]{margin-top:10px;font-style:normal;font-weight:400;font-size:18px;line-height:24px;color:var(--q4s-neutral-750)}", ""]);
// Exports
module.exports = exports;
